import { render, staticRenderFns } from "./JournalStats.vue?vue&type=template&id=53ee812e&scoped=true"
import script from "./JournalStats.vue?vue&type=script&lang=js"
export * from "./JournalStats.vue?vue&type=script&lang=js"
import style0 from "./JournalStats.vue?vue&type=style&index=0&id=53ee812e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ee812e",
  null
  
)

export default component.exports